import MoaPanel from "./moa_panel";
import { MoaFormAnatomy, MOA_FORM_BASE_HTML_CLASS, renderStatusHint } from "../helpers/moa_panel_hints";

// ForgotForm — in-card password-reset request (replaces the old page-nav to
// /forgot_password, which dumped native-app users out of the pane). Submit →
// host.requestPasswordReset (enumeration-uniform RESET_SENT); Back → host.closeForgot
// (return to the password panel it came from). The email is prefilled from the
// address the user already entered.
export const ForgotFormConfig = {
  componentTypeKey: "MoaForgotForm",
  baseHtmlClass: MOA_FORM_BASE_HTML_CLASS,
  selector: ".member_offer_acceptor__form--forgot",
  phase: "forgot",

  emailInputSelector: ".member_offer_acceptor__form__field--email input",
  hintSelector: MoaFormAnatomy.hintSelector,
  backButtonSelector: MoaFormAnatomy.backButtonSelector,
};

export class ForgotForm extends MoaPanel {
  static get config() { return ForgotFormConfig; }

  constructor(id_or_element, host) {
    super(id_or_element, host, ForgotFormConfig);

    this.emailInput = this.element.querySelector(ForgotFormConfig.emailInputSelector);
    this.hintEl = this.element.querySelector(ForgotFormConfig.hintSelector);
    this.backButton = this.element.querySelector(ForgotFormConfig.backButtonSelector);
    this.defaultHint = this.hintEl.textContent;

    this.element.addEventListener("submit", this.handleSubmit.bind(this));
    this.backButton.addEventListener("click", this.handleBack.bind(this));
  }

  handleSubmit(event) {
    event.preventDefault();
    this.host.requestPasswordReset(this.emailInput.value);
  }

  handleBack(event) {
    event.preventDefault();
    this.host.closeForgot();
  }

  render() {
    this.renderPanelVisibility();

    this.emailInput.disabled = !!this.readStateMachineValue("authBusy");

    // Keep the field synced to the address the user is signing in with (authEmail) —
    // but never clobber what they're actively typing. Syncing while unfocused (rather
    // than only-when-empty) means a changed email carries through correctly instead of
    // the field staying stuck on the first address entered this session.
    if (document.activeElement !== this.emailInput) {
      this.emailInput.value = this.readStateMachineValue("authEmail") || "";
    }

    renderStatusHint(this.hintEl, this.readStateMachineValue("authStatus"), this.defaultHint);
  }
}
